module.exports = __webpack_public_path__ + "static/media/wolffox2.af68ccb5.jpg";